import {
  Component,
  OnInit
} from '@angular/core';

import { Observable, of, switchMap } from 'rxjs';

import { IProviderShareableLink, ShareableLinksService } from '@sondermind/data-access/shareable-links';
import { SondermindApplicationService } from '@sondermind/data-access/sondermind-app-service';
import { ProviderUser } from '@sondermind/utilities/models-user-provider';
import { BreakpointsService } from '@sondermind/utilities/services';
import { IconSizes } from '@sondermind/iris/icon';

@Component({
  selector: 'potential-clients-view-card',
  templateUrl: './potential-clients-view-card.component.html',
  styleUrls: [
    './potential-clients-view-card.component.scss'
  ],
  standalone: false,
})
export class PotentialClientsViewCardComponent implements OnInit {
  readonly iconSizes = IconSizes;
  isTiny$: Observable<boolean> = of(false);
  user$: Observable<ProviderUser>;
  shareLink$: Observable<IProviderShareableLink>;

  constructor(
    private appService: SondermindApplicationService,
    private shareableLinksService: ShareableLinksService,
    private breakpointService: BreakpointsService
  ) { }

  ngOnInit(): void {
    this.isTiny$ = this.breakpointService.isTiny$;
    this.shareLink$ = this.appService.currentUser$.pipe(
      switchMap((user) => this.shareableLinksService.getByProviderId$(
        user.personaProviderId
      ))
    );
  }
}
